import React, { useMemo } from 'react';
import { usePos } from '../context/PosContext';
import './Sections.css';

// Product-wise sales report (the "E"/estimate report screen in the drawer).
const EReports: React.FC = () => {
  const { sales, formatMoney } = usePos();

  const rows = useMemo(() => {
    const map = new Map<string, { name: string; qty: number; revenue: number; tax: number }>();
    sales
      .filter((s) => s.status === 'completed')
      .forEach((s) => {
        const share = s.subtotal > 0 ? s.tax / s.subtotal : 0;
        s.items.forEach((i) => {
          const r = map.get(i.productId) ?? { name: i.name, qty: 0, revenue: 0, tax: 0 };
          r.qty += i.quantity;
          r.revenue += i.total;
          r.tax += i.total * share;
          map.set(i.productId, r);
        });
      });
    return Array.from(map.values()).sort((a, b) => b.revenue - a.revenue);
  }, [sales]);

  const grand = rows.reduce((a, r) => ({ qty: a.qty + r.qty, revenue: a.revenue + r.revenue }), { qty: 0, revenue: 0 });

  return (
    <div className="section-page">
      <div className="page-header">
        <h1>E - Reports (Product-wise Sales)</h1>
      </div>
      <div className="section-card">
        {rows.length === 0 ? (
          <p className="muted">No sales yet.</p>
        ) : (
          <table className="section-table">
            <thead>
              <tr>
                <th>Product</th>
                <th className="num-cell">Qty Sold</th>
                <th className="right">Tax</th>
                <th className="right">Revenue</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.name}>
                  <td>{r.name}</td>
                  <td>{r.qty}</td>
                  <td className="right">{formatMoney(r.tax)}</td>
                  <td className="right" style={{ fontWeight: 700, color: 'var(--color-primary-dark)' }}>
                    {formatMoney(r.revenue)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {rows.length > 0 && (
          <div className="totals-line">
            <span>Qty: {grand.qty}</span>
            <span>Revenue: {formatMoney(grand.revenue)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EReports;
